var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesforce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.82 1.963a4.58 4.58 0 013.297-1.4 4.61 4.61 0 014.01 2.352 5.595 5.595 0 012.268-.477A5.6 5.6 0 0126 8.031a5.599 5.599 0 01-6.71 5.484 4.104 4.104 0 01-3.576 2.076 4.115 4.115 0 01-1.792-.408A4.677 4.677 0 019.619 18a4.675 4.675 0 01-4.388-3.027A4.338 4.338 0 012.17 6.971a4.919 4.919 0 01-.416-1.983C1.754 2.233 4.016 0 6.804 0c1.638 0 3.093.77 4.016 1.963",
    fill: "#00A1E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforce);
export default ForwardRef;